"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Button_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Button"));
var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var polished_1 = require("polished");
var em_1 = tslib_1.__importDefault(require("polished/lib/helpers/em"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importStar(require("react"));
var utilities_2 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var BORDER_RADIUS = 4;
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  box-shadow: 0px 3px 7px 0 rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-wrap: wrap;\n  border-radius: ", "px;\n  margin-bottom: ", ";\n  flex-direction: column;\n  align-items: flex-start;\n  overflow: hidden;\n  background-color: ", ";\n  ", " {\n    flex-direction: row;\n  }\n"], ["\n  box-shadow: 0px 3px 7px 0 rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-wrap: wrap;\n  border-radius: ", "px;\n  margin-bottom: ", ";\n  flex-direction: column;\n  align-items: flex-start;\n  overflow: hidden;\n  background-color: ",
    ";\n  ", " {\n    flex-direction: row;\n  }\n"])), BORDER_RADIUS, function (_a) {
    var theme = _a.theme;
    return em_1["default"](theme.grid.gutterWidth);
}, function (_a) {
    var theme = _a.theme;
    return polished_1.readableColor(theme.app.textColor, '#333', '#fff');
}, utilities_1.mb('xs'));
var ButtonWrapper = styled_components_1["default"].a(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  text-decoration: none;\n  color: inherit;\n  margin-top: 0.7em;\n"], ["\n  text-decoration: none;\n  color: inherit;\n  margin-top: 0.7em;\n"])));
var Description = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  max-width: 100%;\n"], ["\n  max-width: 100%;\n"])));
var WrapperDescription = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-self: stretch;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-direction: column;\n  padding: ", ";\n  flex: 1;\n  max-width: 100%;\n"], ["\n  display: flex;\n  align-self: stretch;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-direction: column;\n  padding: ", ";\n  flex: 1;\n  max-width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return em_1["default"](theme.grid.gutterWidth);
});
var TitleImage = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  ", " {\n    flex-shrink: 0;\n    width: 33%;\n  }\n"], ["\n  width: 100%;\n  ", " {\n    flex-shrink: 0;\n    width: 33%;\n  }\n"])), utilities_1.mb('xs'));
var Name = styled_components_1["default"]('div')(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 100%;\n"], ["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 100%;\n"])));
var WidgetDocument = /** @class */ (function (_super) {
    tslib_1.__extends(WidgetDocument, _super);
    function WidgetDocument() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WidgetDocument.prototype.renderItem = function (name, url, description, picture, index) {
        if (index === void 0) { index = 0; }
        return (react_1["default"].createElement(Wrapper, { key: index + "-" + url, className: "content-widget-document-item" },
            picture && (react_1["default"].createElement(TitleImage, { picture: picture, naturalWidth: 400, naturalHeight: 300, script: "resize" })),
            react_1["default"].createElement(WrapperDescription, null,
                name && react_1["default"].createElement(Name, null, name || url),
                description && react_1["default"].createElement(Description, null, description),
                react_1["default"].createElement(ButtonWrapper, { target: "_blank", href: url },
                    react_1["default"].createElement(Button_1["default"], { icon: "attach", basic: true, primary: true }, "Stiahn\u00FA\u0165")))));
    };
    WidgetDocument.prototype.render = function () {
        var _this = this;
        var _a = this.props.data, name = _a.title, publicUrl = _a.uri;
        var items = utilities_2.getProp(this.props, ['data', 'files'], null);
        if (!items && !publicUrl && this.props.renderEmpty) {
            return this.props.renderEmpty(this.props.data.type);
        }
        if (items) {
            return (react_1["default"].createElement("div", { className: "content-widget-document" }, items.map(function (item, idx) {
                var name = item.name, publicUrl = item.public_url, picture = item.picture, description = item.description;
                if (publicUrl) {
                    return _this.renderItem(name, publicUrl, description, picture, idx);
                }
                return null;
            })));
        }
        if (publicUrl) {
            // toto je pre pripad spatnej kompatibility
            // widget document zhruba od septembra 2018 podporuje
            // pridavanie viacero dokumentov naraz
            return (react_1["default"].createElement("div", { className: "content-widget-document" }, this.renderItem(name, publicUrl)));
        }
        return null;
    };
    return WidgetDocument;
}(react_1.PureComponent));
WidgetDocument.propTypes = {
    data: prop_types_1["default"].shape({
        files: prop_types_1["default"].arrayOf(prop_types_1["default"].shape({
            public_url: prop_types_1["default"].string.isRequired,
            name: prop_types_1["default"].string.isRequired
        }).isRequired)
    }).isRequired
};
exports["default"] = WidgetDocument;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
